import { useNavigate } from "react-router-dom";
import { AlertTriangle, Clock, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { subscriptionStatus, fmtDate } from "@/lib/tournament";

export default function SubscriptionBanner({ className = "" }) {
  const nav = useNavigate();
  const { user } = useAuth();
  const { state, daysLeft, expires } = subscriptionStatus(user);

  if (state !== "expiring" && state !== "expired") return null;

  const expired = state === "expired";
  const Icon = expired ? AlertTriangle : Clock;
  const accent = expired ? "#ef4444" : "#eab308";

  const title = expired
    ? "Your subscription has expired"
    : daysLeft === 0
      ? "Your subscription expires today"
      : `Your subscription expires in ${daysLeft} day${daysLeft === 1 ? "" : "s"}`;

  const desc = expired
    ? "Tournament Suite access is paused. Renew now to keep creating brackets, registrations and umpire scoring."
    : `It's valid until ${fmtDate(expires)}. Renew now so you don't lose access to the Tournament Suite.`;

  return (
    <div
      data-testid={`subscription-banner-${state}`}
      className={`rounded-2xl glow-border p-4 sm:p-5 flex items-start gap-4 ${className}`}
      style={{ background: "var(--surface)", borderColor: accent }}
    >
      <div className="w-10 h-10 rounded-xl glass flex items-center justify-center shrink-0">
        <Icon className="w-5 h-5" style={{ color: accent }} />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-display font-bold" style={{ color: accent }}>{title}</h3>
        <p className="text-sm mt-1" style={{ color: "var(--text-2)" }}>{desc}</p>
      </div>
      <button
        data-testid="subscription-banner-renew"
        onClick={() => nav("/subscribe")}
        className="btn-glow rounded-full px-4 py-2 text-sm font-bold flex items-center gap-2 shrink-0 self-center"
      >
        {expired ? "Renew" : "Renew now"} <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}
